import axios from "axios";

const state = {
    regularizaciones: null,
    regularizacionSeleccionada: null,
    totalPaginas: null,
};

const getters = {
    regularizaciones: (state) => state.regularizaciones,
    regularizacionSeleccionada: (state) => state.regularizacionSeleccionada,
    totalPaginas: (state) => state.totalPaginas,
};

const mutations = {
    setRegularizaciones: (state, regularizaciones) => {
        state.regularizaciones = regularizaciones;
    },
    setRegularizacionSeleccionada: (state, regularizacionSeleccionada) => {
        state.regularizacionSeleccionada = regularizacionSeleccionada;
    },

    setTotalPaginas: (state, data) => {
        state.totalPaginas = data;
    },
};

const actions = {

    async consultarRegularizaciones({commit}) {
        try {
            let res = await axios.get(`/v1/regularizaciones`);
            commit("setRegularizaciones", res?.data?.result.solicitudes);
        } catch (error) {
            return error;
        }
    },
    async consultarRegularizacionesPagina({commit}, data) {
        try {
            let res = await axios.get(`/v1/regularizaciones/pagina/${data.pagina}`);
            commit("setRegularizaciones", res?.data?.result);
        } catch (error) {
            return error;
        }
    },
    async consultarRegularizacionesTotalPagina({commit}) {
        try {
            let res = await axios.get(`/v1/regularizaciones/total`);
            commit("setTotalPaginas", res?.data);
        } catch (error) {
            return error;
        }
    },
    async cargarArchivo({commit}, data) {
        try {
          const headers = { 'Content-Type': 'multipart/form-data' };
          await axios.post(`/v1/regularizaciones/upload`, data, { headers });
          commit("setMensaje", "Se ha cargado con éxito el archivo");
          return "success"
        } catch (error) {
            console.log(error);
          return "error";
        }
      },
    async consultarXFechas({commit}, data) {
        try {
            let res = await axios.get(`/v1/regularizaciones/${data.fechaInicio}/${data.fechaFin}`);
            commit("setRegularizaciones", res?.data?.result.solicitudes);
        } catch (error) {
            return error;
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
